import Model from 'scomponent/src/data/model'
import { ItemModel } from '@/store/models/ItemModel'
import fieldTranslation from '../../../.env.models.json'

export class ItemCartModel extends Model {
  private static instance: ItemCartModel = new ItemCartModel()
  productId: number = 0
  name: string = ''
  image: string = ''
  price: number = 0
  quantity: number = 0
  value: number = 0

  public static getInstance(): ItemCartModel {
    this.instance.setTranslateField(fieldTranslation['Product'])
    return ItemCartModel.instance
  }

  public assignItemData(item: ItemModel, quantity: number = 1): this {
    this.productId = item.id
    this.name = item.name
    this.image = item.image
    this.price = item.salePrice
    this.quantity = quantity
    this.value = this.price * this.quantity
    return this
  }

  public assignLocalData(itemData: any): this {
    this.productId = itemData.productId
    this.name = itemData.name
    this.image = itemData.image
    this.price = itemData.price
    this.quantity = itemData.quantity
    this.value = this.price * this.quantity
    return this
  }

  setQuantity(quantity?: number) {
    if (!quantity) {
      this.quantity++
    } else {
      this.quantity = quantity
    }
    this.value = this.price * this.quantity
    return this
  }
}
